import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';

@Component({
  selector: 'app-access-home',
  templateUrl: './access-home.component.html',
  styleUrl: './access-home.component.css',
})
export class AccessHomeComponent {
  isDarkMode: boolean = false;
  store: any;
  currentImage: string = '';

  constructor(
    private readonly analitycs: AnalitycsService,
    private readonly router: Router,
    private storeData: Store<any>,
  ) {
    localStorage.setItem('light', 'dark');
    this.storeData
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
      });
  }

  ngOnInit() {
    this.analitycs.logEvent('acceso_inicial_home', {
      pantalla: 'access-home',
      accion: 'clic',
      detalle: 'botón_inicial',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });
    // Suponiendo que guardaste el tema ('dark' o 'light') en localStorage
    const theme = localStorage.getItem('theme') || 'system';
    this.currentImage = theme === 'dark' ? '../../assets/images/logo-23.png' : '../../assets/images/logo-22.png';
  }

  @Input() services: string[] = [];

  showModal = false;
  showCompanyPlate = false;
  isMobile: boolean = false;
  isMapVisible: boolean = false;
  isSmallScreen: boolean = true;
  viewModal: boolean = false;

  goToassistant() {
    this.analitycs.logEvent('acceso_asistente', {
      pantalla: 'access-home',
      accion: 'clic',
      detalle: 'botón_asistente',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });
    this.router.navigate(['/assistant']);
  }

  register(type: 'taller' | 'empresa') {
    console.log(type);
  }

  chatAssistant(service: string) {
    this.analitycs.logEvent('acceso_asistente', {
      pantalla: 'access-home',
      accion: 'clic',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });
    this.router.navigate(['/assistant'], { queryParams: { service } });
  }

  GoToLogin() {
    this.analitycs.logEvent('acceso_login', {
      pantalla: 'access-home',
      accion: 'clic',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });
    this.router.navigate(['../login']);
  }
  toggleFaq() {
    this.viewModal = true;
  }
  closeModal() {
    this.viewModal = false;
  }
}
